import { PERSIST_SCHEMA_VERSION } from "@funded-here-interface/common/src/constant/persistConfig";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer, type PersistedState } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import { adminReducers } from "./reducers";

// One-time migration: clear orphaned localStorage persist key
// (admin switched from localStorage to sessionStorage for persistence)
if (localStorage.getItem("persist:root")) {
  localStorage.removeItem("persist:root");
}

const persistConfig = {
  key: "root",
  version: PERSIST_SCHEMA_VERSION,
  storage: storageSession,
  whitelist: ["auth"], // Add other reducers you want to persist here
  migrate: async (state: PersistedState, currentVersion: number): Promise<PersistedState> => {
    if (!state) return undefined;
    if (state._persist.version === currentVersion) return state;
    const { auth } = state as PersistedState & { auth?: unknown };
    return { auth, _persist: state._persist } as PersistedState;
  },
};
const persistedReducer = persistReducer(persistConfig, combineReducers(adminReducers));

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
